export class LoginRequest {
  constructor(public cmd: string, public username: string, public password: string) { }
}
